import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenStorageService } from '../services/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AcademymanagerGuard implements CanActivateChild {

  constructor(private tokenStorageService: TokenStorageService, private router: Router) { }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const user = this.tokenStorageService.getUser();
      const authorizedRoles = ['academymanager'];
      if (authorizedRoles.includes(user?.userdata?.rolename)) {
      const authorizedModules = this.tokenStorageService.getUserPermissions() ?? [];
      if (!authorizedModules.length) {
        return this.router.parseUrl('/manage/login');
      }
      const authorizedRoutePaths = this.getAuthorizedRoutePaths(authorizedModules);
      const isRouteAuthorized: boolean = this.authorizedRoutePathCheckFunc(authorizedRoutePaths, state);
      return (isRouteAuthorized) ? true : this.router.parseUrl(authorizedRoutePaths[0] || '/manage/login');
    }
    return true;
  }

  getAuthorizedRoutePaths(authorizedModules) {
    const authorizedRoutePaths = authorizedModules.flatMap(module => (module.hasOwnProperty('submodule') && module['submodule'].length > 0) ? module.submodule.map(submodule => submodule.url) : [module.url]);
    return authorizedRoutePaths;
  }

  authorizedRoutePathCheckFunc(authorizedRoutePaths, state) {
    const isRouteAuthorized: boolean = authorizedRoutePaths.some(url => state.url === url || state.url.startsWith(`${url}/`) || state.url.startsWith(`${url}?`));
    return isRouteAuthorized;
  }

}
